<!--
  -  Copyright (c) Qwoach LLC 2022. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 8/2/2022
  -->

<template>
	<a :href="hrefComputed"
	   :target="targetComputed"
		@click.stop="$emit('click')">
		<slot>
			{{linkComputed}}
		</slot>
	</a>
</template>

<script>
import BaseComponent from "@/core/components/BaseComponent.vue";
import {ellipsisMiddle} from "@/utils/helpers.js";

export default {
	name: "CopyLinkView",
	extends: BaseComponent,
	props: {
		link: String,
		href: String,
		buttonType: String,
		linkText: {String},
		external: {Boolean, default: true},
		target: {String, default: "input"}
	},

	computed: {
		targetComputed() {
			return this.target || (this.external ? "_blank" : "")
		},

		hrefComputed() {
			return this.href || this.link
		},

		linkComputed(){
			let text = this.linkText || this.hrefComputed
			return ellipsisMiddle(text, 30)
		}
	},

}
</script>

<style lang="scss">

</style>
